import { Component, OnInit, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import {Pipe} from '@angular/core';
import {IOption} from 'ng-select';
import { CalendarComponent } from 'ng-fullcalendar';
import { Options } from 'fullcalendar';
import * as moment from 'moment/moment';
import * as $ from 'jquery';
import { Popup } from 'ng2-opd-popup';
import { DialogService,DialogComponent} from 'ng2-bootstrap-modal';
import {AlertHistoryComponent} from '../alert-history/alert-history.component';

@Component({
  selector: 'app-calender',
  templateUrl: './calender.component.html',
  styleUrls: ['./calender.component.scss']
})
export class CalenderComponent implements OnInit {
	calendarOptions: Options;
	ListAllHistroyDetails=[];
	finalArr=[];
	AllMakedetails=[];
	listContractLevel=[];
	AllModalDetails=[];
	calendarOptions1: Options;
	calendarOptions2: Options;
	myFormsOptionsemirates:Array<IOption>=[];
	myFormsOptionSublocality:Array<IOption>=[];
	Emiratesedit="SELECT A EMIRATES";
	Sublocalityedit="SELECT A SUBLOCALITY";
	data = [];
	listSearchData:any[] = [];
  	date:any;
  	CustomerName:any;
  	Location:any;
  	Make:any;
  	Model:any;
  	MechineSerialNumber:any;
  	ServiceType:any;
  	Labour:any;
  	Spares:any;
	Travel:any;
	ListOfCustomerMaster:any[] = [];
	customerDetails:any[] = [];
	Response:any[] = [];
	ListOfCheckListMaster:any[] = [];
	startingCount:number = 0;
	endingCount:number = 0;
	p: number = 1;
	histroy:any[]=[];
  	clientName:any;
  	serialNumber:any;
  	mcLocation:any;
  	phoneNumber:any;
  	email:any;
  	make:any;
  	model:any;
  	hmrHours:any;
  	technicianName:any;
  	lastServiceType:any;
  	lastServiceHours:any;
  	yearOfManufacture:any;
  	branch:any;
  	serviceContractOfferedYear:any;
  	contractReference:any;
  	noofServiceContractYears:any;
  	startDate:any;
  	endDate:any;
  	noOfservice:any;
  	serviceRemainderDays:any;
  	currentService:any;	
	ListserviceDetails:any;
	histroyPP:any[] = [];
	reqmodelId;
 	reqMakeId;
 	ListAllMake = [];
 	ListAllModel = [];
 	ListAllServcieType = [];
  	@ViewChild('Histroy') Histroy: Popup;
  	ServiceContractExtend = [];
  	histroyPr = [];
  	ListTechnicianName = [];
  	techinicianDetails = [];
  	errformdate:boolean=false;
	errtodate:boolean=false;
	orgId:number;
	userId:number;
	ListModeldetailsOnly = [];
	ResponseModel = [];
	calendarStatus:string='Location';
	radio='service';
	LocationName:string;
	Listbranchdetails=[];
	events;
	ListEmiratesdetails = [];
	alerttxt:any;
	ListofSublocality=[];
	Emirates:any;
	Sublocality:any;
	showlocation:boolean=false;
	color:any;
	locality:any;
	ListbranchDetails = [];
	loading:boolean=true;
	@ViewChild(CalendarComponent) ucCalendar: CalendarComponent;
	@ViewChild(CalendarComponent) ucCalendar1: CalendarComponent;
	
	constructor(private dialogservice:DialogService,private router:Router,private route : ActivatedRoute,private http: Http) { }

  	ngOnInit() {
  		//this.loading=true;
  		if(this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null){
	    	window.location.href = 'https://still.alshirawi.com/highmessaging/';
	    } else {
	      this.orgId=this.route.params['value'].orgId;
	      this.userId=this.route.params['value'].userId;
	      console.log('OrgId '+ this.orgId);
	      console.log('UserId '+ this.userId);
	    }
  		this.getAllDetailsFromCustomerMaster();
  		this.getbranchdetails();
  		this.getemiratesdetails();
		  this.getAllSublocalitydetails();
		  this.getmodeldetailsforhistory();
		  this.getmakedetailsforhistory();
		  this.getBranchDetails();
  		

  		this.calendarOptions = {
	        editable: true,
	        eventLimit: true,
	        firstDay:6,
	        header: {
	          left: 'prev,next today',
	          center: 'title',
	          right: 'month'
	        },
	        selectable: true,
	        showNonCurrentDates: false, 
	        eventRender: function(event, element, view) {
		        return $('<div>' + event.title + '</div>');
		    },

	       	events: []
	    };

	   
  	}
  	reset() {
  		this.Emiratesedit="SELECT A EMIRATES";
		this.Sublocalityedit="SELECT A SUBLOCALITY";
		this.Emirates='';
		this.Sublocality='';
		this.defaultEmirates();
	  }

	  getBranchDetails(){
		let obj={
		 'orgId':this.orgId
		}
		return this.http.post('/api/getbranchdetails',obj).subscribe(res=>{
			 this.ListbranchDetails=res.json();
		})
	 }

	  getmodeldetailsforhistory() {
		// this.loading=true;
		   let modelObj = {
			 'orgId':this.orgId
		   }
		   return this.http.post('/api/getModelDetails', modelObj).subscribe(
			res => {
			
			  this.AllModalDetails = [];
			  let response = res.json();
			  if(response.length>0) {
				this.AllModalDetails =response;
				//this.model = response[0].model.toUpperCase();;
			  }else{
				this.loading=false;
			  }
			},(err)=>{
			  this.loading=false;
			//	this.spinner.hide();
			})
		 }
	  
	  getmakedetailsforhistory() {
  
        let makeObj = {
          'orgId':this.orgId
        }
        return this.http.post('/api/getMakedetails', makeObj).subscribe(
         res => {
      
           this.AllMakedetails=[];
           let response = res.json();
           if(response.length>0) {
             this.AllMakedetails = response;
             
           }else{
             this.loading=false;
           }
         },(err)=>{
           this.loading=false;
          // this.spinner.hide();
         })
	  }
	  
  	getDetails(value){
	  
	    let pusharr = [];
	    this.data = [];
	  	this.events=[];
	    this.myFormsOptionSublocality = [];
		let subloc:any;
	    for(let i=0;i<this.ListofSublocality.length;i++){
	      if(this.ListofSublocality[i].emirateid==parseInt(value)){
			  subloc=this.ListofSublocality[i].sublocation || ''
	         pusharr.push({'value':this.ListofSublocality[i]._id.toString(),'label':subloc.toUpperCase()})
	       
	      }
	    }
	    this.myFormsOptionSublocality=pusharr;

	    this.getcalendardetailsBasedonEmirates();
	  }


  		
	getemiratesdetails(){
	    let emiratesObj = {
	    	'orgId':this.orgId
	    }
	    return this.http.post("/api/getEmiratesdetails",emiratesObj).subscribe(res=>{
		  let responseEmirates=res.json();
	      this.ListEmiratesdetails=responseEmirates.result_data;
	      if(this.ListEmiratesdetails.length > 0) {
	        console.log("this.ListEmiratesdetails",this.ListEmiratesdetails);
	        let pusharr=[];
			let emi:any;
	        for(let i=0;i<this.ListEmiratesdetails.length;i++){
				emi=this.ListEmiratesdetails[i].emirates || ''
	          pusharr.push({'value':this.ListEmiratesdetails[i]._id.toString(),'label':emi.toUpperCase()})
	        }
	        this.myFormsOptionsemirates=pusharr;
			console.log('emirates ', this.myFormsOptionsemirates)
	      } else {
			this.loading=false;
	      }
	      
	    },err=>{
			this.loading=false;
	      if(err.status!=200){
	        this.alerttxt="Unable to load the Emirates value";
	        //this.getWarningFunction(this.alerttxt);
	      }
	    })
	}

	getAllSublocalitydetails() {
	    let Sublocality = {
	    'orgId':this.orgId
	    }
	    return this.http.post("/api/getSubLocalitydetails",Sublocality).subscribe(res=>{
		  this.ListofSublocality=res.json().result_data;
	      
	      if(this.ListofSublocality.length > 0) {
	        //console.log("this.ListEmiratesdetails",this.ListEmiratesdetails);
	        let pusharr=[];
			let subloc:any;
	        for(let i=0;i<this.ListofSublocality.length;i++){
				subloc = this.ListofSublocality[i].sublocation || ''
	          pusharr.push({'value':this.ListofSublocality[i]._id.toString(),'label':subloc.toUpperCase()})
	        }
	        this.myFormsOptionSublocality=pusharr;
	      } else {
           this.loading=false;
	      }
	    },err=>{
			this.loading=false;
	      if(err.status!=200){
	        this.alerttxt="Unable to load the Sublocality value";
	        //this.getWarningFunction(this.alerttxt);
	      }
	    })
	  }

	  radiochange(value) {
	  console.log('value ', value);
	  	if(value == "service") {
	  		this.loading=true;
	  		this.showlocation=false;
			this.getcalendardetails();
			this.calendarOptions = {
	        editable: true,
	        eventLimit: true,
	        firstDay:6,
	        header: {
	          left: 'prev,next today',
	          center: 'title',
	          right: 'month'
	        },
	        selectable: true,
	        showNonCurrentDates: false, 
	       	events: []
	    };
		} else if(value == "hours") {
			this.loading=true;
			this.showlocation=false;
			this.calendarOptions1 = {
		        editable: true,
		        eventLimit: true,
		        firstDay:6,
		        header: {
		          left: 'prev,next today',
		          center: 'title',
		          right: 'month'
		        },
		        selectable: true,
		        showNonCurrentDates: false, 
		       	events: []
		    };
			this.getcalendarHoursdetails();
		} else if(value == "emirate") {
			this.loading=true;
			this.showlocation=true;
			this.calendarOptions2 = {
		        editable: true,
		        eventLimit: true,
		        firstDay:6,
		        header: {
		          left: 'prev,next today',
		          center: 'title',
		          right: 'month'
		        },
		        selectable: true,
		        showNonCurrentDates: false, 
		       	events: []
		    };
			this.defaultEmirates();

		}
	  }
	  getDetailsSublocality() {

	  }

	  getlocationdetails() {
	  	this.loading=true;
	  	this.data = [];
	  	this.events=[];
		let reqObj = {
  			'orgId':this.orgId
  		}
  		return this.http.post('/api/getAllServiceDetailsForCalendar', reqObj).subscribe(
     	res => {
     		let Resonse = res.json();
     		let reqPMSObj = {
		        'orgId':this.orgId,
		        'emirate':this.Emirates,
		        'locality':this.Sublocality
		    }
		    return this.http.post('/api/getAllPreventiveMaintenanceDetailsbasedonLocation',reqPMSObj).subscribe(
		        res => {
		       	let PMSResponse = res.json();

		       	let reqObj = {};
	     		if(Resonse.length>0) {
	     			for(let i=0;i<Resonse.length;i++) {
	     				for(let p=0;p<PMSResponse.length;p++) {
	     					if(Resonse[i].serialNumber == PMSResponse[p].serial_Number) {
	     						for(let ls=0;ls<this.ListAllServcieType.length;ls++) {
									if(this.ListAllServcieType[ls]._id == parseInt(PMSResponse[p].Servicedetails[PMSResponse[p].serviceScheduleDay-1].service_Type)) {
										this.lastServiceType = this.ListAllServcieType[ls].servicetype;
									}
								}
								for(var k =0;k<this.customerDetails.length;k++) {
						      		if( PMSResponse[p].client_Name == this.customerDetails[k].Id){
						      			this.clientName = this.customerDetails[k].Name;
						      		}
						      	}
								for(let ls=0;ls<this.ListModeldetailsOnly.length;ls++) {
									if(this.ListModeldetailsOnly[ls]._id == parseInt(PMSResponse[p].model)) {
										this.model = this.ListModeldetailsOnly[ls].model.toUpperCase();
									}
								}

								for(let ls=0;ls<this.ListEmiratesdetails.length;ls++) {
									if(this.ListEmiratesdetails[ls]._id == parseInt(this.Emirates)) {
										this.color = this.ListEmiratesdetails[ls].color;
									}
								}

								for(let ls=0;ls<this.ListofSublocality.length;ls++) {
									if(this.ListofSublocality[ls]._id == parseInt(this.Sublocality)) {
										this.locality = this.ListofSublocality[ls].sublocation;
									}
								}
								
								reqObj = {
				     				title:  this.clientName+'\n '+ this.lastServiceType+'\n '+this.model+'\n'+this.locality.toUpperCase(),
				     				serialNumber:Resonse[i].serialNumber,
								    start: Resonse[i].service_CarriedOut_Date,
									end: Resonse[i].service_CarriedOut_Date,
									pmId:PMSResponse[i]._id,
								    color:this.color
				     			}
			     				this.data.push(reqObj);
					     	}
	     				}
	     				
		     			
		     			
		     		}
	     		} else {

	     		}
	     		this.calendarOptions2.events = [];
	     		this.calendarOptions2.events = this.data;
	     	
				$('#myCalendar2').fullCalendar('renderEvents', this.data, true);
				this.loading=false;
       		},(err)=>{
       			console.log(err);
       			this.loading=false;
       		})
     		
     	},(err)=>{
     		console.log(err);
     		this.loading=false;
     	})
	  }
	getAllDetailsFromCheckListMaster () {
  		let modelObj = {
			'orgId':this.orgId
		}
	    return this.http.post('/api/getModelDetails', modelObj).subscribe(
	    res => {
	    
	    	this.ResponseModel = res.json();
	    		      
	    },(err) =>{
	      console.log(err);
	    })
	}

	getbranchdetails(){
	    let branchObj = {
	      'orgId':this.orgId
	    }
	    return this.http.post("/api/getbranchdetails",branchObj).subscribe(res=>{
	      let responseBranch=res.json();
	      this.Listbranchdetails=responseBranch;
	      //console.log(responseBranch);
	    },err=>{
	      console.log(err);
	    })
	  }

	chooseStatus() {
		
	}

	chooseLocation(location) {
		
		this.calendarOptions.events = [];
		this.LocationName = location;
	}

	
	getcalendardetails() {
	
		this.data = [];
		let reqObj = {
  			'orgId':this.orgId
  		}
  		return this.http.post('/api/getAllServiceDetailsForCalendar', reqObj).subscribe(
     	res => {
			 let Resonse = res.json();
			 
     		let reqPMSObj = {
		        'orgId':this.orgId
		    }
		    return this.http.post('/api/getAllPreventiveMaintenanceDetails',reqPMSObj).subscribe(
		        res => {
		       	let PMSResponse = res.json();

		       	let reqObj = {};
	     		if(Resonse.length>0) {
	     			for(let i=0;i<Resonse.length;i++) {
	     				for(let p=0;p<PMSResponse.length;p++) {
	     					if(Resonse[i].serialNumber == PMSResponse[p].serial_Number) {
	     						for(let ls=0;ls<this.ListAllServcieType.length;ls++) {
									if(this.ListAllServcieType[ls]._id == parseInt(PMSResponse[p].Servicedetails[PMSResponse[p].serviceScheduleDay-1].service_Type)) {
										this.lastServiceType = this.ListAllServcieType[ls].servicetype;
									}
								}
								for(var k =0;k<this.customerDetails.length;k++) {
						      		if( PMSResponse[p].client_Name == this.customerDetails[k].Id){
						      			this.clientName = this.customerDetails[k].Name;
						      		}
						      	}
								for(let ls=0;ls<this.ListModeldetailsOnly.length;ls++) {
									if(this.ListModeldetailsOnly[ls]._id == parseInt(PMSResponse[p].model)) {
										this.model = this.ListModeldetailsOnly[ls].model.toUpperCase();
									}
								}

								for(let ls=0;ls<this.ListofSublocality.length;ls++) {
									if(this.ListofSublocality[ls]._id == parseInt(PMSResponse[p].subLocalityId)) {
										this.locality = this.ListofSublocality[ls].sublocation;
									}
								}

								for(let ls=0;ls<this.ListEmiratesdetails.length;ls++) {
									if(this.ListEmiratesdetails[ls]._id == parseInt(this.Emirates)) {
										this.color = this.ListEmiratesdetails[ls].color;
									}
								}
						
								if(Resonse[i].status == 0) {
	     							reqObj = {
					     				title:  this.clientName+'\n '+ this.lastServiceType+'\n '+this.model+'\n'+this.locality.toUpperCase(),
					     				serialNumber:Resonse[i].serialNumber,
									    start: Resonse[i].service_CarriedOut_Date,
										end: Resonse[i].service_CarriedOut_Date,
										pmId:Resonse[i].pm_Id,
									    color:'#ff8ba4'
					     			}
			     				} else if(Resonse[i].status == 1) {
			     					reqObj = {
					     				title: this.clientName+'\n '+ this.lastServiceType+'\n '+this.model+'\n'+this.locality.toUpperCase(),
					     				serialNumber:Resonse[i].serialNumber,
									    start: Resonse[i].service_CarriedOut_Date,
										end: Resonse[i].service_CarriedOut_Date,
										pmId:Resonse[i].pm_Id,
									    color:'#02898c'
					     			}
			     				}
							
						
							
							
		     				this.data.push(reqObj);
							//  console.log('this.data ', this.data)
					     	}
	     				}
	     				
		     			
		     			
		     		}
	     		} else {
					//	this.loading=false;
	     		}
	     		this.calendarOptions.events = [];
	     		this.calendarOptions.events = this.data;
	     	
				$('#myCalendar').fullCalendar('renderEvents', this.data, true);
				this.loading=false;

       		},(err)=>{
       			this.loading=false;
       			console.log(err);
       		})
     		
     	},(err)=>{
     		this.loading=false;
     		console.log(err);
     	})
	}

	defaultEmirates() {
	
	
		this.data = [];
		let reqObj = {
  			'orgId':this.orgId
  		}
  		return this.http.post('/api/getAllServiceDetailsForCalendar', reqObj).subscribe(
     	res => {
     		let Resonse = res.json();
     		let reqPMSObj = {
		        'orgId':this.orgId
		    }
		    return this.http.post('/api/getAllPreventiveMaintenanceDetails',reqPMSObj).subscribe(
		        res => {
		       	let PMSResponse = res.json();

		       	let reqObj = {};
	     		if(Resonse.length>0) {
	     			for(let i=0;i<Resonse.length;i++) {
	     				for(let p=0;p<PMSResponse.length;p++) {
	     					if(Resonse[i].serialNumber == PMSResponse[p].serial_Number) {
	     						for(let ls=0;ls<this.ListAllServcieType.length;ls++) {
									if(this.ListAllServcieType[ls]._id == parseInt(PMSResponse[p].Servicedetails[PMSResponse[p].serviceScheduleDay-1].service_Type)) {
										this.lastServiceType = this.ListAllServcieType[ls].servicetype;
									}
								}
								for(var k =0;k<this.customerDetails.length;k++) {
						      		if( PMSResponse[p].client_Name == this.customerDetails[k].Id){
						      			this.clientName = this.customerDetails[k].Name;
						      		}
						      	}
								for(let ls=0;ls<this.ListModeldetailsOnly.length;ls++) {
									if(this.ListModeldetailsOnly[ls]._id == parseInt(PMSResponse[p].model)) {
										this.model = this.ListModeldetailsOnly[ls].model.toUpperCase();
									}
								}

								for(let ls=0;ls<this.ListofSublocality.length;ls++) {
									if(this.ListofSublocality[ls]._id == parseInt(PMSResponse[p].subLocalityId)) {
										this.locality = this.ListofSublocality[ls].sublocation;
									}
								}

								for(let ls=0;ls<this.ListEmiratesdetails.length;ls++) {
									if(PMSResponse[p].emiratesId == this.ListEmiratesdetails[ls]._id) {
										this.color = this.ListEmiratesdetails[ls].color;
									}
								}
							
								
									reqObj = {
					     				title:  this.clientName+'\n '+ this.lastServiceType+'\n '+this.model+'\n'+this.locality.toUpperCase(),
					     				serialNumber:Resonse[i].serialNumber,
									    start: Resonse[i].service_CarriedOut_Date,
										end: Resonse[i].service_CarriedOut_Date,
										pmId:Resonse[i].pm_Id,
									    color:this.color
					     			}
							
								
								
			     				this.data.push(reqObj);
					     	}
	     				}
	     				
		     			
		     			
		     		}
	     		} else {
				//	this.loading=false;
	     		}
	     		this.calendarOptions2.events = [];
	     		this.calendarOptions2.events = this.data;
	     		 
				$('#myCalendar2').fullCalendar('renderEvents', this.data, true);
				this.loading=false;

       		},(err)=>{
       			this.loading=false;
       			console.log(err);
       		})
     		
     	},(err)=>{
     		this.loading=false;
     		console.log(err);
     	})

	}

	getcalendardetailsBasedonEmirates() {
		
		this.data = [];
		let reqObj = {
  			'orgId':this.orgId
  		}
  		return this.http.post('/api/getAllServiceDetailsForCalendar', reqObj).subscribe(
     	res => {
     		let Resonse = res.json();
     		let reqPMSObj = {
		        'orgId':this.orgId,
		        'emirate':this.Emirates
		    }
		    return this.http.post('/api/getAllPreventiveMaintenanceDetailsbaesdOnEmirates',reqPMSObj).subscribe(
		        res => {
		       	let PMSResponse = res.json();

		       	let reqObj = {};
	     		if(Resonse.length>0) {
	     			for(let i=0;i<Resonse.length;i++) {
	     				for(let p=0;p<PMSResponse.length;p++) {
	     					if(Resonse[i].serialNumber == PMSResponse[p].serial_Number) {
	     						for(let ls=0;ls<this.ListAllServcieType.length;ls++) {
									if(this.ListAllServcieType[ls]._id == parseInt(PMSResponse[p].Servicedetails[PMSResponse[p].serviceScheduleDay-1].service_Type)) {
										this.lastServiceType = this.ListAllServcieType[ls].servicetype;
									}
								}
								for(var k =0;k<this.customerDetails.length;k++) {
						      		if( PMSResponse[p].client_Name == this.customerDetails[k].Id){
						      			this.clientName = this.customerDetails[k].Name;
						      		}
						      	}
								for(let ls=0;ls<this.ListModeldetailsOnly.length;ls++) {
									if(this.ListModeldetailsOnly[ls]._id == parseInt(PMSResponse[p].model)) {
										this.model = this.ListModeldetailsOnly[ls].model.toUpperCase();
									}
								}

								for(let ls=0;ls<this.ListofSublocality.length;ls++) {
									if(this.ListofSublocality[ls]._id == parseInt(PMSResponse[p].subLocalityId)) {
										this.locality = this.ListofSublocality[ls].sublocation;
									}
								}

								for(let ls=0;ls<this.ListEmiratesdetails.length;ls++) {
									if(PMSResponse[p].emiratesId == this.ListEmiratesdetails[ls]._id) {
										this.color = this.ListEmiratesdetails[ls].color;
									}
								}
							
								
									reqObj = {
					     				title:  this.clientName+'\n '+ this.lastServiceType+'\n '+this.model+'\n'+this.locality.toUpperCase(),
					     				serialNumber:Resonse[i].serialNumber,
									    start: Resonse[i].service_CarriedOut_Date,
										end: Resonse[i].service_CarriedOut_Date,
										pmId:Resonse[i].pm_Id,
									    color:this.color
					     			}
							
								
								
			     				this.data.push(reqObj);
					     	}
	     				}
	     				
		     			
		     			
		     		}
	     		} else {
				//	this.loading=false;
	     		}
	     		this.calendarOptions2.events = [];
	     		this.calendarOptions2.events = this.data;
	     		
				$('#myCalendar2').fullCalendar('renderEvents', this.data, true);
				this.loading=false;

       		},(err)=>{
       			this.loading=false;
       			console.log(err);
       		})
     		
     	},(err)=>{
     		this.loading=false;
     		console.log(err);
     	})
	}

	getcalendarHoursdetails() {
	
		this.data = [];
		let FinalDate = [];
		let FinalHours = [];
		let arrF= []
		let getHourD = [];
		let getDateD= [];
		let arrD = [];
		let getHourC = [];
		let getDateC = [];
		let arrC = [];
		let reqObj = {
  			'orgId':this.orgId
  		}
  		return this.http.post('/api/getAllServiceDetailsForCalendar', reqObj).subscribe(
     	res => {
     		
     		let Resonse = res.json();
     		let reqPMSObj = {
		        'orgId':this.orgId
		    }
		    return this.http.post('/api/getAllPreventiveMaintenanceDetails',reqPMSObj).subscribe(
		        res => {
		        
		       	let PMSResponse = res.json();

		       	let reqObj = {};
	     		if(Resonse.length>0) {
	     			for(let i=0;i<Resonse.length;i++) {
	     				for(let p=0;p<PMSResponse.length;p++) {
	     					if(Resonse[i].serialNumber == PMSResponse[p].serial_Number) {
	     						
								for(let nt=0;nt<PMSResponse[p].serviceScheduleDay;nt++) {
									if(PMSResponse[p].Servicedetails[nt].date == Resonse[i].service_CarriedOut_Date) {
										FinalDate.push({'date':Resonse[i].service_CarriedOut_Date,'serialNumber':Resonse[i].serialNumber,'pmId':Resonse[i].pm_Id,});
										FinalHours.push({
											'date':Resonse[i].service_CarriedOut_Date,
											'labourHour':PMSResponse[p].Servicedetails[nt].labour_hour,
											'travelHour':PMSResponse[p].Servicedetails[nt].travel_hour
										})
									}
									
								}
								
								
								if(Resonse[i].status == 0) {
									let HourobjD = {
										'date':Resonse[i].service_CarriedOut_Date,
										'labourHour':PMSResponse[p].Servicedetails[PMSResponse[p].serviceScheduleDay-1].labour_hour,
										'travelHour':PMSResponse[p].Servicedetails[PMSResponse[p].serviceScheduleDay-1].travel_hour
									}
									getDateD.push({'date':Resonse[i].service_CarriedOut_Date,'serialNumber':Resonse[i].serialNumber,'pmId':Resonse[i].pm_Id});
									getHourD.push(HourobjD);
								} else if(Resonse[i].status == 1) {
									for(let nt=0;nt<PMSResponse[p].serviceScheduleDay;nt++) {
										if(PMSResponse[p].Servicedetails[nt].date == Resonse[i].service_CarriedOut_Date) {
											let HourobjC = {
												'date':Resonse[i].service_CarriedOut_Date,
												'labourHour':PMSResponse[p].Servicedetails[nt].labour_hour,
												'travelHour':PMSResponse[p].Servicedetails[nt].travel_hour
											}
											getDateC.push({'date':Resonse[i].service_CarriedOut_Date,'serialNumber':Resonse[i].serialNumber,'pmId':Resonse[i].pm_Id});
											getHourC.push(HourobjC);
										}
										
									}
			     					
			     					
			     				}
			     				//this.data.push(reqObj);
					   
	     				}// if close
	     				
		     		}	
		     			
		     		}// for loop close
		     	
				    arrD = Array.from(new Set(getDateD))
					console.log('arrD ', arrD)
				    let labourHoursD=0;
				    let travelHoursD=0;
				    for(let uniqueD=0;uniqueD<arrD.length;uniqueD++) {
				    	labourHoursD=0;
						travelHoursD=0;
				    	for(let countD=0;countD<getHourD.length;countD++) {
				    		if(arrD[uniqueD].date == getHourD[countD].date) {
				    			labourHoursD += getHourD[countD].labourHour;
				    			travelHoursD += getHourD[countD].travelHour;
				    		}
				    	}
				    	let totalD = labourHoursD+travelHoursD
				    	reqObj = {
				    		title:  'Service Due Hours'+'\n'+'Labour '+labourHoursD+'\n '+ 'Travel '+travelHoursD+'\n '+'Total '+totalD+'\n'+'serialNumber'+arrD[uniqueD].serialNumber,
							labourhour:labourHoursD,
							travelhour:travelHoursD,
							start: arrD[uniqueD],
							end: arrD[uniqueD],
							color:'#ff8ba4',
							pmId:arrD[uniqueD].pmId,
							serialNumber:arrD[uniqueD].serialNumber
					    }
					    
					    // this.data.push(reqObj);
					    // console.log("due data object "+ reqObj);
					    // console.log("due data "+ this.data);
					    
				    }

				   
				    arrC = Array.from(new Set(getDateC))
				   	let labourHoursC:number=0;
				    let travelHoursC:number=0;
				    for(let uniqueC=0;uniqueC<arrC.length;uniqueC++) {
				    	labourHoursC=0;
						travelHoursC=0;
				    	for(let countC=0;countC<getHourC.length;countC++) {
				    		if(arrC[uniqueC].date == getHourC[countC].date) {
				    			labourHoursC += getHourC[countC].labourHour;
				    			travelHoursC += getHourC[countC].travelHour;
				    		}
				    	}
				    	let totalC = labourHoursC+travelHoursC;
				    	reqObj = {
			     				title: 'Completed Service Hours'+'\n'+'Labour '+labourHoursC+'\n '+ 'Travel '+travelHoursC+'\n '+'Total '+totalC+'serialNumber'+arrC[uniqueC].serialNumber,
			     				labourhour:labourHoursC,
			     				travelhour:travelHoursC,
			     				start: arrC[uniqueC],
								end: arrC[uniqueC],
								color:'#02898c',
								pmId:arrC[uniqueC].pmId,
								serialNumber:arrC[uniqueC].serialNumber
					    }
					    
					    // this.data.push(reqObj);
					    // console.log("Complete data object "+ reqObj);
					    // console.log("Complete data "+ this.data);
					    
					}

				    arrF = Array.from(new Set(FinalDate))
					let labourHoursF:number=0;
				    let travelHoursF:number=0;
				    for(let f=0;f<arrF.length;f++) {
				    	labourHoursF=0;
						travelHoursF=0;
				    	for(let countf=0;countf<FinalHours.length;countf++) {
				    		if(arrF[f].date == FinalHours[countf].date) {
				    			labourHoursF += FinalHours[countf].labourHour;
				    			travelHoursF += FinalHours[countf].travelHour;
				    		}
				    	}
				    	let totalF = labourHoursF+travelHoursF;
				    	reqObj = {
							title: 'Total Service Hours'+'\n'+'Labour '+labourHoursF+'\n '+ 'Travel '+travelHoursF+'\n '+'Total '+totalF,
							labourhour:labourHoursF,
							travelhour:travelHoursF,
							start: arrF[f].date,
							end: arrF[f].date,
							color:'blue',
							pmId:arrF[f].pmId,
							serialNumber:arrF[f].serialNumber
					    }
					    this.data.push(reqObj);
					    // console.log("Complete data object "+ reqObj);
					    // console.log("Complete data "+ this.data);
					}

					

	     		} else {
					//this.loading=false;
	     		}
	     		this.calendarOptions1.events = this.data;
	     		
				$('#myCalendar1').fullCalendar('renderEvents', this.data, true);
				this.loading=false;
			},(err)=>{
				this.loading=false;
				console.log(err);
			})
     	},(err)=>{
     		this.loading=false;
     		console.log(err);
     	})
	}

	
	
	eventClick(data) {

		this.viewHistory(data.event.pmId, data.event.serialNumber);
	}

	getModelDetailOnly() {
		
		let serviceTypeObj = {
			'orgId':this.orgId
		}
	    return this.http.post('/api/getModelDetails', serviceTypeObj).subscribe(
        res => {
			   this.ListModeldetailsOnly = res.json();
			   if(res.json().length>0){
				
			   }else{
				   this.loading=false;
			   }
			   this.getcalendardetails();
        },(err)=>{
        	this.loading=false;
        	this.getcalendardetails();
       		alert('unable to load make values')
        })
	}

	getAllServiceTypeDetails() {
		let serviceTypeObj = {
			'orgId':this.orgId
		}
	    return this.http.post('/api/getServiceTypedetails', serviceTypeObj).subscribe(
        res => {
       		this.ListAllServcieType = res.json();
       		this.getTechnicianName();
        },(err)=>{
        	this.loading=false;
        	this.getTechnicianName();
       		alert('unable to load make values')
        })
	}

	getAllDetailsFromCustomerMaster () {
		let reqObj = {
			'orgId':this.orgId
		}
  		return this.http.post('/api/getCustomerMasterDetails', reqObj).subscribe(
     	res => {
		
			 if(res.json().length>0){
				this.ListOfCustomerMaster = res.json();
			 
				for(var i=0;i<this.ListOfCustomerMaster.length;i++) {
					let obj = {
						'Id':this.ListOfCustomerMaster[i]._id,
						'Name':this.ListOfCustomerMaster[i].customer_Name
					}
					this.customerDetails.push(obj);
				}
				this.getAllServiceTypeDetails();
			 }else{
				 this.loading=false;
			 }
			 
      	},(err)=>{
      		this.loading=false;
      		this.getAllServiceTypeDetails();
      	})
  	}

  	getTechnicianName() {
		this.getModelDetailOnly();
  		let techObj = {
        	'orgId':this.orgId
	  	}
		// return this.http.post('/api/getTechniciansName', techObj).subscribe(
	    // res => {
        // 	res.json();
		// 	this.ListTechnicianName = res.json();
			
		// 		let technicianArr = []
		// 		for(var i=0;i<this.ListTechnicianName.length;i++) {
		// 		  let obj = {
		// 			'label':this.ListTechnicianName[i].FIRST_NAME +' '+ this.ListTechnicianName[i].LAST_NAME,
		// 			'value':this.ListTechnicianName[i].ID
		// 		  }
		// 		  technicianArr.push(obj);
		// 		}
		// 		this.techinicianDetails = technicianArr;
		// 		this.getModelDetailOnly();
			
	        
		// },(err)=>{
		// 	this.loading=false;
		// 	console.log(err);
		// 	this.getModelDetailOnly();
		// })
	}


	getmakedetails() {
      let makeObj = {
        'makeId':this.reqMakeId,
        'orgId':this.orgId
      }
      return this.http.post('/api/getMakedetailsBasedOnId', makeObj).subscribe(
       res => {
         let response = res.json();
         if(response.length>0) {
           this.make = response[0].make.toUpperCase();;
         }
       },(err)=>{
       	console.log(err);
       })
    }

    getmodeldetails() {
      let modelObj = {
        'modelId':this.reqmodelId,
        'orgId':this.orgId
      }
      return this.http.post('/api/getModeldetailsBasedOnId', modelObj).subscribe(
       res => {
         let response = res.json();
		 let mod:any;
         if(response.length>0) {
		   this.model = response[0].model.toUpperCase();;
         }
       })
    }



	showAlert(){
		this.loading=false;
		console.log("ListAllHistroyDetails",this.ListAllHistroyDetails)
			this.dialogservice.addDialog(AlertHistoryComponent,{title:'View History',values:this.ListAllHistroyDetails,contractlevelArr:this.listContractLevel,'finalArr':this.finalArr,'customIndex':0})
		
	  }

	  viewHistory(pmId, serialNumber) {
		let ReqObjValue = {
			'pmId':pmId
		}
		return this.http.post('/api/getHistoryDetailsBasedOnContractLevel', ReqObjValue).subscribe(
    	res=>{ 
			this.histroy = res.json();
			this.clientName="";
			this.technicianName="";
			this.lastServiceType = "";
       		this.ListAllHistroyDetails=[];
			for(let h=0;h<this.histroy.length;h++) {
				
				for(var k =0;k<this.customerDetails.length;k++) {
					if( this.histroy[0].client_Name == this.customerDetails[k].Id){
					  this.clientName = this.customerDetails[k].Name
					}
				  }
				  //this.extensionUpdateId = this.histroy[h]._id
				  for(let m=0;m<this.AllMakedetails.length;m++ ) {
					if(this.AllMakedetails[m]._id == parseInt(this.histroy[h].make)) {
									  
					  this.make = this.AllMakedetails[m].make;
					}
					}
				
					for(let n=0;n<this.ListbranchDetails.length;n++){
						if(this.ListbranchDetails[n]._id==this.histroy[h].branch){
						 this.histroy[h].branch=this.ListbranchDetails[n].branchAlias
						}
					}
	  
				  for(let md=0;md<this.AllModalDetails.length;md++ ) {
					if(this.AllModalDetails[md]._id == parseInt(this.histroy[h].model)) {
					  this.model = this.AllModalDetails[md].model;
					}
				  }
				  for(let t=0;t<this.techinicianDetails.length;t++) {
					if(this.techinicianDetails[t].value == parseInt(this.histroy[h].technician_Name)) {
					  this.technicianName = this.techinicianDetails[t].label;
					}
					}
				
				  for(let ls=0;ls<this.ListAllServcieType.length;ls++) {
					if(this.ListAllServcieType[ls]._id == parseInt(this.histroy[h].last_Service_Type)) {
					  this.lastServiceType = this.ListAllServcieType[ls].servicetype;
					}
					}
					// for(let ls=0;ls<this.ListAllServcieType.length;ls++) {
    	// 		  for(let i=0;i<this.histroy[h].Servicedetails.length;i++) {
     // 				 if(this.histroy[h].serviceScheduleDay-1 > i ){
     //   					if(this.ListAllServcieType[ls]._id ==this.histroy[h].Servicedetails[i].service_Type ) {
     //    					this.lastServiceType = this.ListAllServcieType[ls].servicetype;
     //   						}
     //  				}

     // 			 }		
    
    	// 	 }
			

					if((this.lastServiceType==undefined||this.lastServiceType=="")&&this.histroy[h].last_Service_Type=="New Vehicle"){
						this.lastServiceType="New Vehicle"
					 }
				
				  for(let i=0;i<this.histroy[h].Servicedetails.length;i++) {
					for(let k=0;k<this.ListAllServcieType.length;k++) {
					  if(parseInt(this.histroy[h].Servicedetails[i].service_Type) == this.ListAllServcieType[k]._id) {
						this.histroy[h].Servicedetails[i].service_Type = this.ListAllServcieType[k].servicetype;
					  }
					}
				
					
				  }
				  let histroyObject = {
					'clientName':this.clientName,
					'pmId':this.histroy[h]._id,
					'serialNumber':this.histroy[h].serial_Number,
					'mcLocation':this.histroy[h].mcLocation,
					'phoneNumber':this.histroy[h].phone_Number,
					'email':this.histroy[h].email,
					'make':this.make,
					'modal':this.model,
					'hmr':this.histroy[h].hmr,
					'contractLevel':this.histroy[h].contractLevel,
					'technicianName':this.technicianName,
					'lastserviceType':this.lastServiceType,
					'lastServiceHours':this.histroy[h].last_Service_Hours,
					'yearOfManufacturer':this.histroy[h].year_Of_manufacturer,
					'branch':this.histroy[h].branch,
					'contractRefernce':this.histroy[h].contract_Reference,
					'noofServiceContractYears':this.histroy[h].noofServiceContractYear,
					'startDate':moment(this.histroy[h].start_Date).format("D MMM YYYY"),
					'endDate':moment(this.histroy[h].end_Date).format("D MMM YYYY"),
					'newstartdate':this.histroy[h].start_Date,
					'newenddate':this.histroy[h].end_Date,
					'noOfservice':this.histroy[h].no_Of_Service,
					'serviceRemainderDays':this.histroy[h].remainderday,
					'currentService':this.histroy[h].serviceScheduleDay,
					'ListserviceDetails': this.histroy[h].Servicedetails,
					'lastServiceStatusOfContract':'',
					'histroyPr':[],
					'histroyPp':[],
					'ServiceContractExtend':[]
	  
							  }
						  
							  this.ListAllHistroyDetails.push(histroyObject);


			}

    		
			
    		let reqObj = {
	          'serialNumber':serialNumber,
	        }
	        return this.http.post('/api/getListAllPostPonedHistroy', reqObj).subscribe(
	        res=>{ 
	   
	          let ppHis = res.json();
	           this.histroyPP = [];
	           this.histroyPr = [];
	           if(ppHis.length>0) {
	            for(var p=0;p<ppHis.length;p++) {
	              if(ppHis[p].type == 'servicePrepone') {
	                let pphis = {
	                  'serialNumber':ppHis[p].serialNumber,
	                  'postPoned_Taken_Date':moment(ppHis[p].postPoned_Taken_Date,).format("D MMM YYYY"),
	                  'postPoned_Remainder_Days':ppHis[p].postPoned_Remainder_Days,
	                  'schedularNumber':ppHis[p].schedularNumber
	                }
					this.histroyPr.push(pphis);
					for(let pr=0;pr<this.ListAllHistroyDetails.length;pr++) {
						if(this.ListAllHistroyDetails[pr].serialNumber == ppHis[p].serialNumber && this.ListAllHistroyDetails[pr].contractLevel == ppHis[p].contractLevel) {
							this.ListAllHistroyDetails[pr].histroyPr = this.histroyPr;
						}
					} //for loop end here
	              } else if(ppHis[p].type == 'servicePostpone') {
	                let pphis = {
	                  'serialNumber':ppHis[p].serialNumber,
	                  'postPoned_Taken_Date':moment(ppHis[p].postPoned_Taken_Date,).format("D MMM YYYY"),
	                  'postPoned_Remainder_Days':ppHis[p].postPoned_Remainder_Days,
	                  'schedularNumber':ppHis[p].schedularNumber
	                }
					this.histroyPP.push(pphis);
					for(let pp=0;pp<this.ListAllHistroyDetails.length;pp++) {
						if(this.ListAllHistroyDetails[pp].serialNumber == ppHis[p].serialNumber && this.ListAllHistroyDetails[pp].contractLevel == ppHis[p].contractLevel) {
							this.ListAllHistroyDetails[pp].histroyPp = this.histroyPP;
						}
					} //for loop end here
	              }
	              
	              
	              
	            }
	          }
	          
	          let reqExtendobj = {
	            'serialNumber':serialNumber,
	          }
	          return this.http.post('/api/getListAllServiceContractExtendHistroy', reqObj).subscribe(
	          res=>{ 
	            let SCExtend = res.json();
	            this.ServiceContractExtend = [];
	            if(SCExtend.length>0) {
	              for(var n=0;n<SCExtend.length;n++) {
	                let SCEobj = {
	                  'serialNumber':SCExtend[n].serialNumber,
	                  'startdate':moment(SCExtend[n].startdate).format("D MMM YYYY"),
	                  'enddate':moment(SCExtend[n].enddate).format("D MMM YYYY"),
	                  'contractExtensionDate':moment(SCExtend[n].contractExtensionDate).format("D MMM YYYY")
	                }
	                this.ServiceContractExtend.push(SCEobj);
	              }
				}
				
				let statusObj = {
					'pmId':this.ListAllHistroyDetails[0].pmId,
					'serialNumber':this.ListAllHistroyDetails[0].serialNumber
				}
				return this.http.post('/api/serviceStatusChecking_serviceFormAPI', statusObj).subscribe(
				res => {
				
					let response = res.json();
					if(response.length > 0) {
						if(response[response.length-1].service_Scheduler_Number == this.ListAllHistroyDetails[0].noOfservice && response[response.length-1].status == 1) {
							this.ListAllHistroyDetails[0].lastServiceStatusOfContract = 'completed';
						} else {
							this.ListAllHistroyDetails[0].lastServiceStatusOfContract = 'notcompleted';
						}
					}
					console.log('this.ListAllHistroyDetails '+ this.ListAllHistroyDetails)
					this.loading=true;
					document.body.scrollTop = 0;
					document.documentElement.scrollTop = 0;
					this.showAlert();
				})
	           
	            
				
	          })
	          
	        })
	        
	    })
	     
	}

	

	close() {
      this.Histroy.hide();
    }
}


// WEBPACK FOOTER //
// ./client/app/calender/calender.component.ts